import React, { useState, useEffect } from "react";
import "./Vendor.css";
import VendorForm from "./VendorForm";
import Pagination from "../../../utils/pagination/Pagination";
import { Trash2, SquarePen, Eye, Plus } from "lucide-react";
import { getVendor } from "../../../redux/reduxApi/vendorReduxApi";
import { countVendor } from "../../../redux/api/vendorApi/VendorApi";
import { useNavigate } from "react-router-dom";

import { Table, Thead, Tbody, Tr, Th, Td, TableContainer, Checkbox, Modal, Spinner, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, Button, ModalCloseButton } from "@chakra-ui/react";
import { Form, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { deleteVendor } from "../../../redux/api/vendorApi/VendorApi";
import { deletevendorAction } from "../../../redux/reduxSlice/VendorSlice";
import ProgressBar from "../../../utils/progressBar/ProgressBar";
import EllipsisMenu from "../../../utils/EllipsisDropdown/EllipsisMenu";

function Vendor() {
  const navigate = useNavigate();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(5);
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch(); //get
  const vendorData = useSelector((state) => state?.vendor?.vendor);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [deleteVendorROWID, setDeleteVendorROWID] = useState(""); //delete
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isUpdateMode, setIsUpdateMode] = useState(false); //create
  const [vendorROWID, setVendorROWID] = useState("");
  const [dataToEdit, setDataToEdit] = useState({});
  //to show add & delete button according to permissions
  const permissions = localStorage.getItem("permissions");
  const filterData = JSON.parse(permissions);

  // get Vendor
  useEffect(() => {
    setLoading(true);
    dispatch(getVendor({ page: currentPage, limit: 30, size: 30 }))
      .catch((error) => {
        console.error("Error fetching Vendor data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [currentPage, dispatch]);

  // total Injury count
  const fetchTotalCount = async () => {
    try {
      const response = await countVendor();
      console.log("API Response:", response.data);
      const count = parseInt(response.data.count, 10);
      setTotalCount(count);
    } catch (error) {
      console.error("Error fetching total Vendor count:", error);
    }
  };
  // add create current record count
  const handleNewData = () => {
    fetchTotalCount();
  };

  useEffect(() => {
    fetchTotalCount();
  }, []);

  // Handle row deletion
  const handleDelete = () => {
    setShowProgressBar(true);
    setLoading(true);
    const idsToDelete = selectedRows.length === 0 ? [deleteVendorROWID] : selectedRows;
    Promise.all(idsToDelete.map((id) => deleteVendor(id)))
      .then(() => {
        setSelectedRows([]);
        dispatch(deletevendorAction(idsToDelete));
        toast.success("Row deleted successfully");
        fetchTotalCount();
      })
      .catch(() => {
        toast.error("Row not deleted");
      })
      .finally(() => {
        setIsOpen(false);
        setDeleteVendorROWID("");
        setShowProgressBar(false);
        setLoading(false);
      });
  };

  // Modal for delete confirmation
  const openTrash = (ROWID) => {
    setDeleteVendorROWID(ROWID);
    setIsOpen(true);
  };
  const closeTrash = () => {
    setIsOpen(false);
    setDeleteVendorROWID("");
  };

  // Handle row selection
  const handleRowSelect = (ROWID) => {
    setSelectedRows((prevSelectedRows) => {
      const isSelected = prevSelectedRows.includes(ROWID);
      const updatedRows = isSelected ? prevSelectedRows.filter((id) => id !== ROWID) : [...prevSelectedRows, ROWID];
      console.log("Selected rows:", updatedRows);
      return updatedRows;
    });
  };

  // Handle "select all" functionality
  const handleSelectAllRows = () => {
    setSelectedRows((prevSelectedRows) => {
      const updatedRows = prevSelectedRows.length === vendorData?.length ? [] : vendorData.map((item) => item?.ROWID);

      console.log("Selected rows:", updatedRows);
      return updatedRows;
    });
  };

  // handle update
  const handleUpdate = (id) => {
    setVendorROWID(id);
    setIsUpdateMode(!isUpdateMode);
  };

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };
  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };
  return (
    <>
      {loading && (
        <div className="spinner-overlay">
          <Spinner size="xl" color="pink.500" />
        </div>
      )}
      {showProgressBar && <ProgressBar colorScheme="pink" />}
      {/* Trash confirmation modal */}
      <Modal isOpen={isOpen} onClose={closeTrash}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Are you sure you want to Delete?</ModalHeader>
          <ModalCloseButton />
          <ModalBody></ModalBody>
          <ModalFooter>
            <Button className="create-button" mr={3} onClick={handleDelete}>
              Delete
            </Button>
            <Button className="cancel-button" onClick={closeTrash}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <div className="d-flex flex-column align-items-end">
        {filterData?.find((mod) => mod.moduleName === "Vendor" && mod.add === true) && (
          <button className="new-button mx-2" onClick={openDrawer}>
            <Plus size="18px" />
            <span className="ms-1">New</span>
          </button>
        )}
        <div className="custom-scroll w-100 " style={{ height: "80vh", overflowX: "scroll" }}>
          <TableContainer
            className="card card-detail mt-1 scrollable-container"
            style={{
              minHeight: "72vh",
              backgroundColor: "#EFEFEF",
              border: "none",
              position: "relative",
              overflow: "scroll",
              scrollbarColor: "#A0AEC0 #EDF2F7",
              scrollbarWidth: "10px",
            }}
          >
            <Table variant="simple" size="sm">
              <Thead>
                <Tr className="tr-border">
                  <Th className="py-1 th-color">
                    <Checkbox isChecked={selectedRows.length === vendorData?.length} onChange={handleSelectAllRows} />
                  </Th>
                  <Th className="py-1 th-color">Actions</Th>
                  {/* <Th className='py-1 th-color'>Vendor Owner</Th> */}
                  <Th className="py-1 th-color">Vendor Name</Th>
                  <Th className="py-1 th-color">Email</Th>
                  <Th className="py-1 th-color">Phone</Th>
                  <Th className="py-1 th-color">Legal Name</Th>
                  <Th className="py-1 th-color">Website</Th>
                  <Th className="py-1 th-color">Gross turnover</Th>
                  <Th className="py-1 th-color">Legal Name</Th>
                  <Th className="py-1 th-color">Current frenchise reference</Th>
                  <Th className="py-1 th-color">How they hear about us</Th>
                  <Th className="py-1 th-color">Operating as a</Th>
                  <Th className="py-1 th-color">Nature of Business</Th>
                </Tr>
              </Thead>
              <Tbody>
                {vendorData?.map((item) => (
                  <Tr className="tr-border" key={item.ROWID} style={{ position: "relative" }}>
                    <Td>
                      <Checkbox isChecked={selectedRows.includes(item.ROWID)} onChange={() => handleRowSelect(item.ROWID)} />
                    </Td>
                    {/* <Td >
                      <Tr className="d-flex gap-1">
                        <Link to="/vendor-detail-view" state={{ ROWID: item?.ROWID }}>
                          <i style={{ cursor: 'pointer' }}><Eye color="#ff176b" size="16px" strokeWidth="1" /></i>
                        </Link>
                        {filterData[12].moduleName === "Vendor" && filterData[12].modifyAll === true ?
                          <i onClick={() => { openDrawer(); setDataToEdit(item); setIsUpdateMode(true); }} style={{ cursor: 'pointer' }}><SquarePen color="#ff176b" size="16px" strokeWidth="1" /></i> : ""}
                        {filterData[12].moduleName === "Vendor" && filterData[12].delete === true ?
                          <i style={{ cursor: 'pointer' }}><Trash2 color="#ff176b" size="16px" strokeWidth="1" onClick={() => openTrash(item.ROWID)} /></i> : ""}
                      </Tr>
                    </Td> */}
                    <Td style={{ width: "110px", textAlign: "center" }} onClick={(e) => e.stopPropagation()}>
                      <EllipsisMenu
                        item={item}
                        onView={() => navigate("/vendor-detail-view", { state: { ROWID: item?.ROWID } })}
                        onEdit={() => {
                          openDrawer();
                          setDataToEdit(item);
                          setIsUpdateMode(true);
                        }}
                        onDelete={() => {
                          openTrash(item.ROWID);
                        }}
                        permissions={{
                          canEdit: filterData?.find((mod) => mod.moduleName === "Vendor" && mod.modifyAll === true),
                          canDelete: filterData?.find((mod) => mod.moduleName === "Vendor" && mod.delete === true),
                          canView: true, // Usually always true, but you can make this dynamic too
                        }}
                      />
                    </Td>
                    {/* <Td className='font-colors'>{item.vendorOwner}</Td> */}
                    <Td className="font-colors">{item.vendorName}</Td>
                    <Td className="font-colors">{item.email}</Td>
                    <Td className="font-colors">{item.phone}</Td>
                    <Td className="font-colors">{item.legalName}</Td>
                    <Td className="font-colors">{item.wbsite}</Td>
                    <Td className="font-colors">{item.grossTurnover}</Td>
                    <Td className="font-colors">{item.legalName}</Td>
                    <Td className="font-colors">{item.currentFrenchiseReference}</Td>
                    <Td className="font-colors">{item.howTheyHearAboutUs}</Td>
                    <Td className="font-colors">{item.operatingAsA}</Td>
                    <Td className="font-colors">{item.natureOfBusiness}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </div>
        <div className="footer">
          <div className="footer d-flex fixed-bottom start-20">
            <div className="total" style={{ marginLeft: "16%", marginTop: "15px" }}>
              <p class="fw-semibold">Total Count: {totalCount}</p>
            </div>
            {/* Pagination */}
            <div className="d-flex align-items-center justify-content-center position-fixed-bottom mx-auto">
              <Pagination totalPages={Math.ceil(totalCount / 30)} onPageChange={setCurrentPage} />
            </div>
            {/* End Pagination */}
            <VendorForm
              closeDrawer={() => setIsDrawerOpen(false)}
              isUpdateMode={isUpdateMode}
              injuryROWID={vendorROWID}
              isDrawerOpen={isDrawerOpen}
              setIsUpdateMode={setIsUpdateMode}
              dataToEdit={dataToEdit}
              onNewDataAdded={handleNewData}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Vendor;
